// Мелкие общие элементы: экран с шапкой, уведомление, кнопка с ожиданием.
import { useEffect, useState, type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { inTelegram, telegramBack } from '../platform/telegram.ts';
import { t } from '../i18n/index.ts';

export function Screen({ title, back, children }: { title?: string; back?: string | boolean; children: ReactNode }) {
  const nav = useNavigate();
  useEffect(() => {
    const go = back ? () => (typeof back === 'string' ? nav(back) : nav(-1)) : null;
    telegramBack(go);
    return () => telegramBack(null);
  }, [back, nav]);
  return (
    <main className="screen">
      {(title || back) && (
        <header className="bar">
          {back && !inTelegram() && <button type="button" className="link" onClick={() => (typeof back === 'string' ? nav(back) : nav(-1))}>← {t('common.back')}</button>}
          {title && <h1>{title}</h1>}
        </header>
      )}
      {children}
    </main>
  );
}

let pushToast: (s: string) => void = () => {};
export const toast = (s: string) => pushToast(s);
export function Toasts() {
  const [msg, setMsg] = useState<string | null>(null);
  useEffect(() => {
    let timer: number | undefined;
    pushToast = s => { setMsg(s); clearTimeout(timer); timer = window.setTimeout(() => setMsg(null), 3500); };
  }, []);
  return msg ? <div className="toast" role="status">{msg}</div> : null;
}

// кнопка, которая блокируется на время запроса
export function Busy({ onClick, children, className = 'btn' }: { onClick: () => Promise<unknown>; children: ReactNode; className?: string }) {
  const [busy, setBusy] = useState(false);
  return (
    <button type="button" className={className} disabled={busy} onClick={async () => { setBusy(true); try { await onClick(); } finally { setBusy(false); } }}>
      {busy ? <span className="spin" aria-label={t('common.loading')} /> : children}
    </button>
  );
}
